


























































































































    import ripple from "./ripple.vue"
    import tooltip from "./tooltip.vue"
    import alert from "./alert.vue"
    import gbutton from "./button.vue"
    import userPopout from "./userPopout.vue"
    import popupDisplay from "./popupDisplay.vue"
    import iconButton from "./iconButtons.vue"
    import {CalendarStructure} from "./calendar.vue"
    import dropdown, {DropdownInterface} from "./dropdownMenu.vue"
    import search,{ SearchRes } from "./search.vue"
    import userIcon from "./userIcon.vue"
    import { Component, Watch, Vue, Prop } from "vue-property-decorator";
    import moment,{ weekdays, Moment } from "moment";
    import * as vClickOutside from 'v-click-outside-x';
    import {nextTick} from "process"
    import { frontendClient } from "../lib/client";
import { fromNode } from "bluebird";


    @Component({
        components:{
            ripple,
            alert,
            tooltip,
            search,
            iconButton,
            gbutton,
            dropdown,
            userPopout,
            popupDisplay,
            userIcon
        }
    })
    export default class Header extends Vue {

        @Prop({}) scopes:{
            default: null,
        }
        @Prop({}) calStates: CalendarStructure;

        selectedItemIndex:number= null;

        userPopoutVisible:boolean = false;
        notificationPopupVisible:boolean = false;
        alertsPopupVisible:boolean = false;
        newPopupVisible:boolean = false;

        newNew:boolean = false;
        newNotification:boolean = false;
        newAlertNotification:boolean = false;
        isTooltipInvisible:boolean = false;
        isAdmin:boolean = false;

        alertTitle = null;
        alertText = null;

        messageTitle = null;
        messageFromID = null;
        messageText = null;
        messageUser = null;

        alertCb: (data) => void;
        messageCb: (data) => void;
        watchWindowEvents(){
            this.alertCb = (data) => {
                if(this.$route.name == "admin-alerts" || this.$route.name == "worker-alerts") return;
                this.alertTitle = data.title;
                this.alertText = data.body;
                this.newAlertNotification = true;
            };
            frontendClient.wsClient.on("newalert",this.alertCb);
            
            this.messageCb = (data) => {
                if(this.$route.name == "admin-chat" || this.$route.name == "worker-chat") return;
                this.messageText = `${data.body}`,
                this.messageFromID = data.fromUserID,
                this.messageTitle = `From ${data.fromUsername}`
                this.newNotification = true;
            };
            frontendClient.wsClient.on("newmessage",this.messageCb);
        }
        
        unwatchWindowEvents(){
            frontendClient.wsClient.removeListener("newalert",this.alertCb);
            frontendClient.wsClient.removeListener("newmessage",this.messageCb);
        }
        
        calendarViews:DropdownInterface = {
            type: "select",
            items: [
                {
                    name:"Month",
                    icon: 'done',
                    function: () => {this.updateView(1)},
                    focus: false,
                },
                {
                    name:"Four weeks",
                    icon: 'done',
                    function: () => {this.updateView(2)},
                    focus: true,
                },
                {
                    name:"Fortnight",
                    icon: 'done',
                    function: () => {this.updateView(3)},
                    focus: false,
                },
                {
                    name:"Week",
                    icon: 'done',
                    function: () => {this.updateView(4)},
                    focus: false,
                },
                {
                    name:"Day",
                    icon: 'done',
                    function: () => {this.updateView(5)},
                    focus: false,
                },
            ]
        }

        daySelectViews:DropdownInterface = {
            type: "select",
            items: [
                {
                    name:"Year",
                    icon: 'done',
                    function: () => {this.updateView(0)},
                    focus: false,
                },
                {
                    name:"Month",
                    icon: 'done',
                    function: () => {this.updateView(1)},
                    focus: true,
                },
                {
                    name:"Four weeks",
                    icon: 'done',
                    function: () => {this.updateView(2)},
                    focus: false,
                },
            ]
        }


        openNav(){
            this.$emit('openNav')
        }

        redirectToChat(){
            if(frontendClient.userData.rank == "admin"){
                this.redirect('admin-chat',{connectedToID:this.messageFromID})
            }else{
                this.redirect('worker-chat',{connectedToID:this.messageFromID})
            }
        }

        redirectToAlerts(){
            if(frontendClient.userData.rank == "admin"){
                this.redirect('admin-alerts')
            }else{
                this.redirect('worker-alerts')
            }
        }

        redirect(route,parameters?){
            this.closeAllpopouts();
            if(parameters){
                this.$router.replace({ name: route, params: parameters});
            }else{
                this.$router.push({ name: route, params: parameters});
            }
        };

        openUser(){
            this.closeAllpopouts();
            this.$emit('popupOpen');
            if(this.userPopoutVisible == false){
                nextTick(() => {
                    this.userPopoutVisible = !this.userPopoutVisible;
                })
            }
        }
        openAlerts(){
            this.closeAllpopouts();
            this.$emit('popupOpen');
            this.newAlertNotification = false;
            this.newNotification = false;
            if(this.alertsPopupVisible == false){
                nextTick(() => {
                    this.alertsPopupVisible = !this.alertsPopupVisible;
                })
            }
        }
        openNotifications(){
            this.closeAllpopouts();
            this.$emit('popupOpen');
            this.newNotification = false;
            this.newAlertNotification = false;
            if(this.notificationPopupVisible == false){
                nextTick(() => {
                    this.notificationPopupVisible = !this.notificationPopupVisible;
                })
            }
        }
        openNew(){
            this.closeAllpopouts();
            this.$emit('popupOpen');
            this.newNew = false;
            if(this.newPopupVisible == false){
                nextTick(() => {
                    this.newPopupVisible = !this.newPopupVisible;
                })
            }
        }

        hideAlerts(){
            this.newNotification = false;
        }

        closeAllpopouts(){
            this.$emit('popupClosed');
            this.closeUser();
            this.closeAlerts();
            this.closeNotifications();
            this.closeNew();
        }

        closeUser() {
            this.userPopoutVisible = false;
            this.isTooltipInvisible = true;
        }
        closeAlerts() {
            this.alertsPopupVisible = false;
            this.isTooltipInvisible = true;
        }
        closeNew() {
            this.newPopupVisible = false;
            this.isTooltipInvisible = true;
        }
        closeNotifications() {
            this.notificationPopupVisible = false;
            this.isTooltipInvisible = true;
        }

        updateView(view){
            this.$route.params.calView = `${view}`;
        }

        calUpdate(direction){
            this.$emit("calendarUpdate", direction)
        }

        redirectToToday(){
            this.$emit("calendarUpdate", (new Date()))
        }

        newJob(){
            this.$emit('newPrompt','job');
            this.closeAllpopouts();
        }
        newAlert(){
            this.$emit('newPrompt','alert');
            this.closeAllpopouts();
        }
        newWalker(){
            this.$emit('newPrompt','walker');
            this.closeAllpopouts();
        }

        mounted(){
            this.checkAdmin();
            this.watchWindowEvents();
        }

        beforeDestroy() {
            this.unwatchWindowEvents();
        }

        checkAdmin(){
            if(frontendClient.userData.rank == "admin"){
                this.isAdmin = true;
            }
        }

        rawResults:any = null;
        async searchEverything(string): Promise<SearchRes[]> {
            this.rawResults = await frontendClient.post("search/do",{
                query:string
            }).catch((err) => {
                setTimeout(() => {
                    frontendClient.giveError("Search failed")
                },0)
            })

            return this.rawResults;
        }
    }

